import { Editor, TinyMCE } from "tinymce";
import { makeEditorModal } from "../Modal";
import { FeatureClass } from "../core/FeatureClass";
import { displayErrors, getData, initEditor, insertToEditor, setWindowNode, toJsonHtml } from "../core/Utils";
import { turnPictureToLabelingTask } from "../Inputs/Labeling";

declare let tinymce:TinyMCE

export function addImage(editor:Editor){
    const config = {
        featureName: "insert-image",
        id: "img",
        icon: "upload",
        tooltip: 'Bild hochladen',
        editor: editor,
        menuItems: [], // maybe later edit image with tool
        buttonAction: (command:string) => {
            editor.focus();
            openModal(editor, command, {points:0, text: ''});
        },
        commandAction: (data) => {
            
        }    
    }

    config.menuItems.push(turnPictureToLabelingTask())


    const feature = new FeatureClass(config);
    feature.addToEditor(editor);
}

function openModal(editor, command){
        const content = '';

        const submitBtn = {
            // text: "Hochladen",
            // class: "upload-file-to-task"
        }

        const exists = document.getElementById("add-file-to-task-editor") !== null;

        const modal = makeModal("add-file-to-task-editor", "Datei hochladen", content, submitBtn, true, 'sm', true);

        const modalHtml = $("#add-file-to-task-editor");
        modalHtml.find(".fast-faq").remove();
        modalHtml.find(".modal-title").append('<span class="fast-faq ms-3" onclick="showQuestion('+ 13 + ');"><i class="fa fa-question-circle"></i></span>')

        if (!exists){
            const html = '<div id="dropzone-wrapper" class="px-2">' +
            '<form id="add-file-to-editor" class="dropzone dz-clickable ml-4 mr-4 d-flex justify-content-center align-items-center" action="/upload">' +
            '<div class="dz-default dz-message mt-1 mb-1">' +
            '<div class="dz-details"><div class="dz-filename"><span data-dz-name></span></div></div>' + 
            '<button class="btn btn-info btn-circle btn-xl me-1 mb-1 upload-info"' +
        'type="button"><i class="fa fa-upload"></i></button>' +
        '<center>' +
        '<span class="upload-title">Hierher ziehen</span>' +
        '<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>' +
        '<div class="dz-error-message"><span data-dz-errormessage></span></div>' +
        '</center>' +
        '</div>' +
        '</form></div>';
            $("#add-file-to-task-editor").find(".modal-body").after(html);
            const dropzone = addDropzone(editor);
        }
        modal.show();
}



function changeDisplayFileName(newName:string){
    $(".upload-title").html(newName);
}


function insertImageToEditor(url:string, editor:Editor){
    const html = '<img id="img" src="' + url +'" width="300px">'
    insertToEditor(html, editor);
}

function addDropzone(editor:Editor){
    const dropzone = new Dropzone('form#add-file-to-editor', {
        maxFilesize: 5,
        autoQueue: true,
        acceptedFiles: ".png,.jpeg,.jpg,.PNG,.JPEG,.JPG",
        uploadMultiple: false,
        parallelUploads: 1,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        init: function(){
            const dz = this;
            dz.on("complete", function(file){
                
            })
            dz.on("success", function(file, response){
                
                hideSpinner($(".upload-info"));
                
                const url = response.path;
                hideModal("add-file-to-task-editor");
                insertImageToEditor(url, tinymce.activeEditor);
   


            })
            dz.on("error", function(one, two){
                errorToast("Konnte nicht hochgeladen werden");
            })
        },     
        addedfile: function(file){
            const btn = $(".upload-info");
            showSpinner(btn);
        },

    })
    return dropzone;
}